import React, { useEffect } from "react";

//MATERIAL UI IMPORTS:
import { Grid, Typography, TextField, FormControl, Select, MenuItem, Tooltip, IconButton, Button, Paper, Card, Container, Box, CardContent , Checkbox, FormControlLabel} from "@mui/material";
import {
    Add as AddIcon,
    Edit as EditIcon,
    FormatListBulleted as FormatListBulletedIcon,
    Inventory2 as Inventory2Icon, 
} from "@mui/icons-material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import * as helpers from "./helpers"
import {
    Notes as NotesIcon,
} from "@mui/icons-material";

//CUSTOM IMPORTS
import TextfieldMontos from "./components/TextfieldMontos";
import Autocomplete from "@mui/material/Autocomplete";
import { useState } from "react";
import DialogLeyenda from "./components/DialogLeyenda";

export default function TablaItems({ items, setItems, setImpNeto, regPrecio, existeCliente, um, hayRemito, productos, anulacionCompleta, leyenda, setLeyenda}) {

    const disabledForm = !!anulacionCompleta || !existeCliente;
    const [editandoDescripcion, setEditandoDescripcion] = useState(null);
    const [showDialogLeyenda, setShowDialogLeyenda] = useState("");

    /* --------------------------- HANDLERS --------------------------------  */

    const onChangeCantidad = (e, index) => {
        const values = [...items];
        const updatedValue = e.target.name;
        values[index][updatedValue] = parseFloat(e.target.value);
        const totalItem = Number((values[index].cantidad * values[index].precioUnitario).toFixed(2)) || 0;
        values[index].totalItem = totalItem;
        values[index]["totalItemCIva"] = new Intl.NumberFormat("es-AR", {
            style: "currency",
            currency: "ARS"
          }).format((totalItem * values[index].valor_iva) || 0)

        if(updatedValue === "precioUnitario"){
            const civa  = e.target.value * values[index].valor_iva;//precio con iva
            values[index]["precioConIva"] = new Intl.NumberFormat("es-AR", {
                style: "currency",
                currency: "ARS"
              }).format(civa || 0)
        }

        setItems(values);
    };

    const onChangeProducto = (producto, index) => {
        const nuevosItems = [...items];

        nuevosItems[index].idProducto =
            producto.idproducto;

        nuevosItems[index].descripcion =
            producto.detalle_factura;

        nuevosItems[index].valor_iva = producto.valor_iva;

        setItems(nuevosItems);
    };

    const onChangeDescripcion = (
        value,
        index
    ) => {

        const nuevosItems = [...items];

        nuevosItems[index].descripcion = value;

        setItems(nuevosItems);
    };

    const onChangeStockeable = (e, index) => {
        const nuevosItems = [...items];
        nuevosItems[index].stockeable = e.target.checked;
        setItems(nuevosItems);
    };


    const onChangeUnidadMedida = (e, index) => {
        const idProductoLinea = items[index].idProducto

        if (!!idProductoLinea) {
            const productoValido = helpers.validaUMProducto(productos, idProductoLinea, e.target.value);
            const precioUnitario = helpers.definePrecioUnitario(regPrecio, um, idProductoLinea, e.target.value)
            

            setItems((prev) => {
                const newItems = [...prev];
                newItems[index].unidadMedida = e.target.value;
                newItems[index].descUnidadMedida = um.find((un) => un.id === e.target.value)?.abreviatura?.toUpperCase() || "";
                newItems[index].precioUnitario = !regPrecio ? 0 : precioUnitario;
                newItems[index].idProducto = !productoValido ? "" : items[index].idProducto;
                newItems[index].totalItem = "";
                newItems[index].descripcion="";
                newItems[index].totalItem = parseFloat((newItems[index].cantidad * newItems[index].precioUnitario).toFixed(2)) || 0;
                return newItems;
            });

            return;
        }

        setItems((prev) => {
            const newItems = [...prev];
            newItems[index].unidadMedida = e.target.value;
            newItems[index].descUnidadMedida = um.find((un) => un.id === e.target.value)?.abreviatura?.toUpperCase() || "";
            return newItems;
        })

    }

    const handleNuevoItem = () => {
        const values = [...items];
        values.push({
            cantidad: "", unidadMedida: "", precioUnitario: "", totalItem: "", idProducto: "", stockeable:true
        });
        setItems(values);
        setTimeout(() => {
            window.scrollTo({
                top: document.body.scrollHeight,
                behavior: 'smooth'
            });
        }, 100);
    };

    const handleEliminarItem = (index) => {
        const values = [...items];
        values.splice(index, 1);
        setItems(values);
    };

    const setProductosOptionsDisabled = (producto, index) => {
        return !(producto?.um.split(",").map(um => Number(um)).includes(items[index].unidadMedida));
    }

    /* --------------------------- EFFECTS --------------------------------  */

    useEffect(() => {
        const neto = items.reduce(
            (total, item) => {
                return total + item.totalItem;
            },
            0
        );
        setImpNeto(neto);
    }, [items])

    /* --------------------------- STYLING --------------------------------  */
    const inputProps = {
        disableUnderline: true,
        sx: {
            paddingBottom: 0,
            height: "26px",
        },
    };

    const inputsx = {
        ".MuiFilledInput-root": {
            paddingTop: 0,
            paddingBottom: 0,
            height: "32px",
        },
        ".MuiInputBase-input": {
            paddingTop: "6px",
            paddingBottom: "6px",
        },
    };
    /* --------------------------- RENDER --------------------------------- */

    const colSize = {
        cantidad: 1.2,
        um: 1.2,
        descripcion: 4.3,
        precioUnitario: 1.5,
        totalItem: 1.5,
        stockeable: 0.5,
        acciones: 1.2
    };

    return (
        <div>
            <Container maxWidth="xl" >
                <Card>
                    <Tooltip
                        title={existeCliente ? "" : "Seleccione un cliente para poder agregar items."}
                        arrow
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    fontSize: '0.9rem',
                                    padding: '10px 12px',
                                },
                            },
                        }}
                    >
                        <Box
                            sx={{
                                backgroundColor: "primary.main",
                                color: "white",
                                p: 1,
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                <FormatListBulletedIcon />
                                <Typography variant="h5" sx={{ fontWeight: 450, fontSize: 15 }} >
                                    Productos y Servicios
                                </Typography>
                            </Box>
                        </Box>
                        <CardContent>
                            <Grid
                                px={1}
                                pt={1}
                                pl={2}
                                container
                                backgroundColor="#fff"
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <Grid item xs={colSize.cantidad}>
                                    <Typography variant="button" color="primary">
                                        Cantidad
                                    </Typography>
                                </Grid>
                                <Grid item xs={colSize.um}>
                                    <Typography variant="button" color="primary">
                                        UM
                                    </Typography>
                                </Grid>
                                <Grid item xs={colSize.descripcion}>
                                    <Typography variant="button" color="primary">
                                        Producto/Servicio
                                    </Typography>
                                </Grid>
                                <Grid item xs={colSize.precioUnitario}>
                                    <Typography variant="button" color="primary" sx={{ fontSize: 14 }}>
                                        P. Unit <b><u>(s/Iva)</u></b>
                                    </Typography>
                                </Grid>
                                <Grid item xs={colSize.totalItem}>
                                    <Typography variant="button" color="primary">
                                        Subtotal (s/Iva)
                                    </Typography>
                                </Grid>
                                <Grid item xs={colSize.stockeable} sx={{ textAlign: "center" }}>
                                    <Typography variant="button" color="primary" >
                                        Stock
                                    </Typography>
                                </Grid>
                                <Grid item xs={colSize.acciones}>
                                    <Typography variant="button" color="primary">
                                        Acciones
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} mb={1}>
                                {items &&
                                    items.map((field, index) => (
                                        <>
                                            <Grid
                                                container
                                                px={1}
                                                py={.5}
                                                direction="row"
                                                justifyContent="space-between"
                                                alignItems="flex-start"
                                                borderRadius={1}
                                                pl={2}
                                            >
                                                <Grid item xs={colSize.cantidad}>
                                                    <TextfieldMontos
                                                        disabled={disabledForm}
                                                        variant={"filled"}
                                                        size={"small"}
                                                        name="cantidad"
                                                        value={field.cantidad}
                                                        onChange={(e) => {
                                                            onChangeCantidad(e, index);
                                                        }}
                                                        InputProps={inputProps}
                                                        inputsx={inputsx}
                                                    />
                                                </Grid>
                                                <Grid item xs={colSize.um}>
                                                    <FormControl fullWidth>
                                                        <Select
                                                            disabled={disabledForm}
                                                            variant="filled"
                                                            size="small"
                                                            value={field.unidadMedida}
                                                            onChange={(e) => {
                                                                onChangeUnidadMedida(e, index);
                                                            }}
                                                            name="unidadMedida"
                                                            sx={{ height: "32px", ...inputsx }}
                                                        >
                                                            {um?.map((unidad) => (
                                                                <MenuItem
                                                                    key={unidad.id}
                                                                    value={unidad.id}
                                                                >
                                                                    {unidad?.abreviatura?.toUpperCase()}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={colSize.descripcion}>
                                                    <Grid container direction="row" justifyContent="flex-start">
                                                        <Grid item xs={12}>
                                                            {
                                                                editandoDescripcion === index
                                                                    ? (
                                                                        <TextField
                                                                            fullWidth
                                                                            autoFocus
                                                                            variant="filled"
                                                                            value={field.descripcion || ""}
                                                                            onChange={(e) =>
                                                                                onChangeDescripcion(
                                                                                    e.target.value,
                                                                                    index
                                                                                )
                                                                            }
                                                                            onBlur={() =>
                                                                                setEditandoDescripcion(null)
                                                                            }
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === "Enter") {
                                                                                    setEditandoDescripcion(null);
                                                                                }
                                                                            }}
                                                                            placeholder="Editar descripción..."
                                                                            sx={inputsx}
                                                                        />
                                                                    )
                                                                    : (
                                                                        <Autocomplete
                                                                            getOptionDisabled={(producto) =>
                                                                                setProductosOptionsDisabled(
                                                                                    producto,
                                                                                    index
                                                                                )
                                                                            }
                                                                            inputValue={field.descripcion || ""}
                                                                            onInputChange={(e, value, reason) => {
                                                                                if (reason === "input") {
                                                                                    onChangeDescripcion(value, index)
                                                                                }
                                                                            }}
                                                                            disabled={disabledForm}
                                                                            disableClearable
                                                                            options={productos || []}
                                                                            value={
                                                                                productos?.find(
                                                                                    (p) =>
                                                                                        p.idproducto ===
                                                                                        field.idProducto
                                                                                ) || null
                                                                            }
                                                                            onChange={(e, value) => {
                                                                                onChangeProducto(value, index)
                                                                            }}
                                                                            noOptionsText={
                                                                                "No se encontraron coincidencias.."
                                                                            }
                                                                            getOptionLabel={(option) =>
                                                                                option?.detalle_factura || ""
                                                                            }
                                                                            renderOption={(props, option) => (
                                                                                <Box
                                                                                    component="li"
                                                                                    key={option.idproducto}
                                                                                    {...props}
                                                                                >
                                                                                    {option.detalle_factura}
                                                                                </Box>
                                                                            )}
                                                                            renderInput={(params) => (
                                                                                <TextField
                                                                                    // helperText={field.idProducto && productos.length ? `ALÍCUOTA IVA DE ESTE PRODUCTO: ${productos?.find(producto => producto.idproducto === field.idProducto)?.iva_descripcion}%` : ``}
                                                                                    helperText={
                                                                                        field.idProducto && productos.length
                                                                                          ? (() => {
                                                                                              const producto = productos.find(
                                                                                                producto => producto.idproducto === field.idProducto
                                                                                              );
                                                                                      
                                                                                              return producto
                                                                                                ? `ALÍCUOTA IVA DE ESTE PRODUCTO: ${producto.iva_descripcion}%`
                                                                                                : "";
                                                                                            })()
                                                                                          : ""
                                                                                      }
                                                                                    {...params}
                                                                                    variant="filled"
                                                                                    fullWidth
                                                                                    placeholder="Buscar producto..."
                                                                                    sx={inputsx}
                                                                                    InputProps={{
                                                                                        ...params.InputProps,
                                                                                        endAdornment: (
                                                                                            <>
                                                                                                {
                                                                                                    field.idProducto && (
                                                                                                        <IconButton
                                                                                                            disabled={disabledForm}
                                                                                                            size="small"
                                                                                                            onClick={() =>
                                                                                                                setEditandoDescripcion(index)
                                                                                                            }
                                                                                                        >
                                                                                                            <EditIcon fontSize="small" />
                                                                                                        </IconButton>
                                                                                                    )
                                                                                                }
                                                                                                {params.InputProps.endAdornment}
                                                                                            </>
                                                                                        )
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        />
                                                                    )
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={colSize.precioUnitario}>
                                                    <TextfieldMontos
                                                        disabled={disabledForm}
                                                        variant={"filled"}
                                                        size={"small"}
                                                        name="precioUnitario"
                                                        value={field.precioUnitario}
                                                        onChange={(e) => {
                                                            onChangeCantidad(e, index);
                                                        }}
                                                        InputProps={inputProps}
                                                        inputsx={inputsx}
                                                        helperText={`C/IVA:${field.precioConIva || 0}`}
                                                    />
                                                </Grid>
                                                <Grid item xs={colSize.totalItem}>
                                                    <TextfieldMontos
                                                        disabled={true}
                                                        variant={"filled"}
                                                        size={"small"}
                                                        name="totalItem"
                                                        value={field.totalItem}
                                                        onChange={(e) => {
                                                            onChangeCantidad(e, index);
                                                        }}
                                                        InputProps={inputProps}
                                                        inputsx={inputsx}
                                                        // helperText={Number(field.totalItemCIva)>0 ? `C/IVA:${field.totalItemCIva}` : " " }
                                                        helperText = {field.totalItemCIva}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={colSize.stockeable}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        // pt: 0.5
                                                    }}
                                                >
                                                    <Tooltip title={field.stockeable ? "Item stockeable (afecta stock p/ estadísticas)" : "Item no stockeable"}>
                                                        <Checkbox
                                                            disabled={disabledForm}
                                                            checked={!!field.stockeable}
                                                            onChange={(e) => onChangeStockeable(e, index)}
                                                            color="primary"
                                                            size="small"
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={colSize.acciones}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "flex-start",
                                                        pr: 3,
                                                    }}
                                                >
                                                    <Tooltip title="Eliminar Item">
                                                        <IconButton
                                                            disabled={items.length === 1}
                                                            onClick={() => handleEliminarItem(index)}
                                                            color="error"
                                                            sx={{ p: 0.5 }}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    {index === items.length - 1 && (
                                                        <Tooltip title="Agregar Item">
                                                            <IconButton
                                                                disabled={disabledForm || hayRemito}
                                                                onClick={() => handleNuevoItem()}
                                                                color="success"
                                                                sx={{ p: 0.5}}
                                                            >
                                                                <AddCircleOutlineIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </>
                                    ))}
                            </Grid>
                            <Grid item xs={12}>
                            </Grid>
                            <Box sx={{ mt: 2, px: 2, display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 1 }}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<NotesIcon />}
                                    onClick={setShowDialogLeyenda}
                                    disabled={disabledForm}
                                    size="small"
                                >
                                    {leyenda ? "Editar leyenda" : "Añadir leyenda"}
                                </Button>
                                {leyenda && (
                                    <Typography variant="body2" color="textSecondary" sx={{ fontStyle: "italic" }}>
                                        <strong>Leyenda ingresada:</strong> {leyenda}
                                    </Typography>
                                )}
                            </Box>
                        </CardContent>
                    </Tooltip>
                </Card>
            </Container>
            {
                showDialogLeyenda && 
                    <DialogLeyenda 
                        openLeyendaModal={showDialogLeyenda} 
                        handleCloseLeyenda={()=>setShowDialogLeyenda(false)} 
                        leyenda={leyenda}
                        setLeyenda={setLeyenda}
                    />
            }
            
        </div>
    )
}


{/* <Grid item xs={12}>
    <Autocomplete
        getOptionDisabled={(producto) => setProductosOptionsDisabled(producto, index)}
        disabled={disabledForm}
        disableClearable
        placeholder="Productos"
        options={productos || []}
        value={productos?.find((p) => p.idproducto === field.idProducto) || null}
        onChange={(e, value) => {
            onChangeProducto(value, index)
        }}
        noOptionsText={"No se encontraron coincidencias para esta búsqueda.."}
        getOptionLabel={(option) => option?.detalle_factura}
        renderOption={(props, option) => (
            <Box
                component="li"
                key={option.idproducto}
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
            >
                {option.detalle_factura}
            </Box>
        )}
        renderInput={(params) => (
            <TextField
                {...params}
                variant="filled"
                fullWidth
                placeholder="Tipee para buscar productos.."
                required
                sx={inputsx}
            />
        )}

    />

</Grid>  */}